import { log } from '@hungryroot/o11y';
import { analytics } from './segment';

declare global {
  interface Window {
    heap?: {
      loaded: boolean;
      addUserProperties: (data: Record<string, string>) => void;
    };
  }
}

type Params = {
  experiment: number;
  variant: number;
};

export function trackExperimentEnrollment({ experiment, variant }: Params) {
  // log experiment enrollment to segment
  analytics.identify({
    traits: {
      experiment,
      variant,
    },
  });

  try {
    window.heap?.addUserProperties({
      [`experiment_${experiment}`]: variant.toString(),
    });
  } catch (e) {
    log('heap.error', {
      method: 'addUserProperties',
      error: e,
      heapState: {
        loaded: window.heap?.loaded,
      },
    });
  }
}
